import { ITrackingDiagnostic, ITrackingDiagnosticsRequestDto } from "types/models/TrackingDiagnosticsModel";
import { BaseService, IBaseService } from "./BaseServiceClass";
import { AxiosInstance } from "axios";
import { APIResponseHandler } from "utilities/ErrorHelper";

export interface ITrackingDiagnosticsService extends IBaseService<ITrackingDiagnostic> {
    getTrackingDiagnostic(userDiagnosticId: string): Promise<any>;
    getAllTrackingDiagnostics(request: ITrackingDiagnosticsRequestDto): Promise<any>;
}

export class TrackingDiagnosticsService extends BaseService<ITrackingDiagnostic> implements ITrackingDiagnosticsService {
    constructor(axiosInstance: AxiosInstance) {
        super(axiosInstance, 'api/trackingdiagnostics');
    }

    getTrackingDiagnostic = async (trackingDiagnosticId: string): Promise<any> => {
        const response = await this._axiosInstance.get(`api/trackingdiagnostics/${trackingDiagnosticId}`);
        return APIResponseHandler(response);
    }

    getAllTrackingDiagnostics = async (request: ITrackingDiagnosticsRequestDto): Promise<any> => {
        const params = new URLSearchParams({
            updatedAfter: request.updatedAfter,
            includeDeleted: request.includeDeleted.toString()
        });

        const response = await this._axiosInstance.get(`api/trackingdiagnostics?${params.toString()}`);
        return APIResponseHandler(response);
    };
}